// src/App.js
import React, { useEffect, useState } from 'react';
import AppWrapper from './AppWrapper';
import PasswordGate from './PasswordGate';

const ALLOWED_DOMAINS = ['getnextvisa.com', 'www.getnextvisa.com'];

export default function App() {
  const [hasAccess, setHasAccess] = useState(true); // default to true for allowed domains
  const [checked, setChecked] = useState(false); // prevent premature render

  useEffect(() => {
    const domain = window.location.hostname;
    if (!ALLOWED_DOMAINS.includes(domain)) {
      const allowed = localStorage.getItem('hasAccess') === 'true';
      setHasAccess(allowed);
    }
    setChecked(true);
  }, []);

  if (!checked) return null; // wait until check completes

  return hasAccess ? (
    <AppWrapper />
  ) : (
    <PasswordGate onAccessGranted={() => setHasAccess(true)} />
  );
}
